module.exports = __webpack_public_path__ + "img/img_clients8.456ab53f.jpg";